import React, { useEffect, useState } from "react";
import { Card } from "react-bootstrap";
import ChartComponent from "../Highcharts/ChartComponent";
import { barConfig } from "../Highcharts/chartconfig";
import axios from "axios";
import Loader from "./Loader";
import { setServiceIndicatorCount } from "../Redux/actions/serviceIndicatorAction";
import { connect } from "react-redux";

const mapDispatchToProps = (dispatch) => ({
  setServiceIndicatorCount: (serviceIndicatorCount) =>
    dispatch(setServiceIndicatorCount(serviceIndicatorCount)),
});

function ClassificationCases({ requestData, setServiceIndicatorCount }) {
  const [chartCounter, setChartCounter] = useState(null);

  useEffect(() => {
    let requestBody = {
      communityId: "fee5c0c217af285485abb2e583cb806c",
    };
    if (Object.keys(requestData).length > 0) {
      let oRequest = { ...requestBody, ...requestData };
      if (
        (requestData?.globalFilters?.dateFilter.to !== "" &&
          requestData?.globalFilters?.dateFilter.from !== "") ||
        (requestData.questionIds != null &&
          requestData.selectedOption != null) ||
        (requestData.subQuestionIds != null &&
          requestData.selectedOption != null) ||
        requestData.serviceIdFilter != null
      ) {
        getClassificationData(oRequest);
      }
    } else {
      getClassificationData(requestBody);
    }
  }, [requestData]);

  let getClassificationData = async (data) => {
    try {
      let res = await axios.post(
        `${process.env.REACT_APP_API_KEY}/opendashboard/getCasesCountByServices`,
        data
      );

      let formatedData = res.data.data.serviceWiseCount;
      const totalCount = (serviceObject) => {
        let serviceTotalCount = 0;
        serviceObject.forEach((service) => {
          serviceTotalCount += service.count;
        });

        return serviceTotalCount;
      };
      let catagoriesArr = [];
      let percentValues = [];
      const arr = formatedData.map((formated) => {
        let servicePercentage;
        servicePercentage = Math.round(
          (formated.count / totalCount(formatedData)) * 100
        );
        catagoriesArr.push(formated.serviceName);
        percentValues.push({
          percent: servicePercentage,
          y: formated.count,
        });
        return { ...formated, servicePercentage };
      });
      let obj = {
        catagoriesArr,
        percentValues,
      };
      setChartCounter(obj);

      setServiceIndicatorCount(arr);
    } catch (error) {
      console.log(error);
    }
  };

  const totalValue = (data) => {
    let values = Object.values(data);
    const sumWithIndictors = values.reduce(
      (accumulator, currentValue) => accumulator + currentValue,
      0
    );
    return sumWithIndictors;
  };

  return (
    <Card>
      {/* <Card.Header>Classification of cases reported</Card.Header> */}
      <Card.Body className="pb-3">
        <h5>Classification of cases reported</h5>
        {chartCounter !== null ? (
          <ChartComponent options={barConfig(chartCounter)} />
        ) : (
          <Loader />
        )}
      </Card.Body>
    </Card>
  );
}

export default connect(null, mapDispatchToProps)(ClassificationCases);
